'use client';
import React from 'react';
import { CategoryTitle as SharedCategoryTitle } from '@launchstore/shared-puck';
import type { CategoryTitleProps } from '@launchstore/shared-puck';
import { useCategory } from '@lib/hooks/useCategory';

const SharedCategoryTitleRender = (SharedCategoryTitle as any).render;

const CategoryTitleImpl: React.FC<CategoryTitleProps> = (props) => {
  const { category } = useCategory() as any;
  return <SharedCategoryTitleRender {...(props as any)} category={category} />;
};

export const CategoryTitle: any = { ...SharedCategoryTitle, render: (props: any) => <CategoryTitleImpl {...props} /> };
export default CategoryTitle;
